import { render, staticRenderFns } from "./OfferStatusForm.vue?vue&type=template&id=72c7674a&scoped=true"
import script from "./OfferStatusForm.vue?vue&type=script&lang=js"
export * from "./OfferStatusForm.vue?vue&type=script&lang=js"
import style0 from "./OfferStatusForm.vue?vue&type=style&index=0&id=72c7674a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c7674a",
  null
  
)

export default component.exports